import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import InstitutionDashboard from '../InstitutionDashboard/InstitutionDashboard';
import CourseDashboard from '../CourseDashboard/CourseDashboard';
import StudentDashboard from '../StudentDashboard/StudentDashboard';

const Dashboard = observer(class Dashboard extends React.Component {
  componentWillMount() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { courseSid } = this.props.routing.location.query;

    if(courseSid) {
      SessionStore.notice = true;
      SessionStore.noticeContent.body = translation.admin_notice;
      SessionStore.userData.courseSid = courseSid;
      SessionStore.getCourseData(courseSid);
    }
  }

  render() {
    const { SessionStore } = this.props.store;
    const { role } = SessionStore.userData;
    let { courseSid } = this.props.routing.location.query;

    if(SessionStore.courseData) {
      courseSid = SessionStore.courseData.sid;
    }

    if(role.toLowerCase() === 'learner') {
      return <StudentDashboard {...this.props} />
    } else if(role.toLowerCase() === 'instructor' || courseSid) {
      if(courseSid) {
        return <CourseDashboard {...this.props} courseSid={courseSid} />
      } else {
        return <CourseDashboard {...this.props} />
      }
    } else {
      return <InstitutionDashboard {...this.props} />
    }
  }
})

export default translate('Dashboard')(Dashboard);


// WEBPACK FOOTER //
// ./src/app/components/Dashboard/Dashboard.js